export default class{
	static uuidv4() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		  var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		  return v.toString(16);
		});
	}

	static binarySearch(d, t, s, e) {
		const m = Math.floor((s + e) / 2);
		if(t === d[m].x) return d[m];
		if(e - 1 === s || s === e) {
			if(Math.abs(d[s].x - t) > Math.abs(d[e].x - t)) {
				return d[e]
			} else {
				return d[s];
			}
		}
		if(t > d[m].x) return this.binarySearch(d, t, m, e);
		if(t < d[m].x) return this.binarySearch(d, t, s, m);
   }

	/* Adds left bias to the end result */
	static binarySearchLeft(d, t, s, e) {
		const m = Math.ceil((s + e) / 2);
		if(t === d[m].x) return d[m];
		if(e - 1 === s || s === e) {
			return d[s]; 
		}
		if(t > d[m].x) return this.binarySearch(d, t, m, e);
		if(t < d[m].x) return this.binarySearch(d, t, s, m);
   }
}


// WEBPACK FOOTER //
// ./src/utils/tooltip.js